import React, { FC } from 'react';
import { makeStyles, Theme } from '@material-ui/core/styles';
import { Box, Avatar, AvatarProps } from '@material-ui/core';
import { getGradientFromTheme } from '../Theme';

export interface BorderedAvatarProps extends AvatarProps {
    radius?: number
    borderType?: 'circular' | 'semicircle'
    edges?: Array<'top' | 'left' | 'right' | 'bottom'>
}

const BorderedAvatar: FC<BorderedAvatarProps> = (props) => {
    const { edges = ['bottom', 'left', 'right', 'top'], borderType = 'circular', radius = USER_AVATAR_RADIUS, children, ...avatarProps } = props;

    const BORDER_RADIUS = `${radius * 2 / 2.5}px`;
    const BORDER_RADIUS_BG = `${radius * 2 / 2.5 + 2}px`;
    const borderRadius = borderType === 'circular' ? `${radius}px` : `${edges.includes('top') ? BORDER_RADIUS : 0} ${edges.includes('right') ? BORDER_RADIUS : 0} ${edges.includes('bottom') ? BORDER_RADIUS : 0} ${edges.includes('left') ? BORDER_RADIUS : 0}`
    const borderRadiusBg = borderType === 'circular' ? `${radius + 2}px` : `${edges.includes('top') ? BORDER_RADIUS_BG : 0} ${edges.includes('right') ? BORDER_RADIUS_BG : 0} ${edges.includes('bottom') ? BORDER_RADIUS_BG : 0} ${edges.includes('left') ? BORDER_RADIUS_BG : 0}`

    const classes = useStyles({ radius, borderRadius, borderRadiusBg });

    return (
        <Box position='relative'>
            <Avatar
                {...avatarProps}
                className={classes.avatar}
            />
            <div
                className={classes.avatarBg}
            />
        </Box>
    )
}

const USER_AVATAR_RADIUS = 50;
const useStyles = makeStyles<Theme, { radius: number, borderRadius: string, borderRadiusBg: string }>((theme) => ({
    avatar: {
        height: props => props.radius * 2,
        width: props => props.radius * 2,
        borderRadius: props => props.borderRadius,
        // height: '100%',
        // width: '100%',
        zIndex: 1,
    },
    avatarBg: {
        zIndex: 0,
        top: -2,
        left: -2,
        position: 'absolute',
        background: getGradientFromTheme(theme),
        height: props => props.radius * 2 + 4,
        width: props => props.radius * 2 + 4,
        borderRadius: props => props.borderRadiusBg,
    },
}));

export default BorderedAvatar;